import React from 'react';
import { Box, Typography } from '@mui/material';

const Logs: React.FC = () => {
  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant="h5" component="h1" fontWeight={600} sx={{ mb: 2 }}>
        Application Logs
      </Typography>
      <Typography variant="body2" color="text.secondary">
        View system logs.
      </Typography>
    </Box>
  );
};

export default Logs;
